export default {
    PAGE_CODE_LENGTH: 6
};